export function SectionA() {
  return (<p>Section A</p>);
}
